export function assertDefined<T>(v: T | null | undefined): asserts v is NonNullable<T> {
  if (v === null || v === undefined) {
    throw new Error('Value is null or undefined');
  }
}
